import React, { useContext, useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import GetSearchResults from '../utils/get-search-results';
import Articles from '../partials/articles';
import { StoreContext } from '../context/store-context';

const ArticlesForYou = () => {
  const [allArticles, setAllArticles] = useState([]);
  const { searchTerm } = useContext(StoreContext);

  const forYou = useStaticQuery(graphql`
    query forYou {
      posts: allWpPost(limit: 4, filter: {status: {eq: "publish"}}) {
        nodes {
          title
          slug
          date
          nodeType
          uri
          excerpt
          content
          id
          featuredImage {
            node {
              mimeType
              altText
              localFile {
                publicURL
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
          }
          categories {
            nodes {
              name
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    if (searchTerm) {
      setAllArticles(GetSearchResults(
        [
          ...forYou.posts.nodes,
        ],
        'post',
        searchTerm,
      ));
    }
  }, [forYou.posts.nodes, searchTerm])

  if(!searchTerm && allArticles.length === 0) {
    return null;
  } else {
    return (
      <div className="Collection__articles__main">
        <h2 className='Title Title--lined'>
          <span>Articles For You</span>
        </h2>
        <Articles articles={allArticles} hideSort={true} />
      </div>
    )
  }
}

export default ArticlesForYou;
